// 运行时常量

const env = import.meta.env

// API 基础地址
export const API_BASE_URL = env.VITE_API_BASE_URL || 'https://woofootball.site'

// /site/* 签名 appkey（与后端 SITE_APPKEY 一致）
export const SITE_APPKEY = env.VITE_SITE_APPKEY || 'yfb'

// 应用名称（dev 模式带 DEV 后缀）
export const APP_NAME_DISPLAY = env.VITE_APP_NAME || 'REPLAY SHIELD'

// 支持的语言（3 语：简体中文 / 繁体中文 / English）
export const SUPPORTED_LOCALES = ['zh-CN', 'zh-TW', 'en'] as const
export type SupportedLocale = typeof SUPPORTED_LOCALES[number]
export const DEFAULT_LOCALE: SupportedLocale = 'zh-CN'

// 本地存储 key
export const STORAGE_KEY = {
  locale: 'yfb.locale'
} as const